import {
    useState,
    useEffect
} from 'react';
import {
    useDispatch
} from 'react-redux'
import {
    clearUser
} from '../slices/authSlice';
//useEffect
const API_URL = process.env.REACT_APP_API_URL;

const useAuthStatus = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [status, setStatus] = useState(null);
    const dispatch = useDispatch();


    useEffect(() => {
        const ResetUserState = () => {
            dispatch(clearUser());
        }
        const fetchUser = async () => {
            const token = localStorage.getItem('token');

            if (!token) {
                setLoading(false);
                return;
            }

            try {
                await fetch(`${API_URL}/api/authstatus`, {
                    credentials: 'include',
                    headers: {
                        'X-CSRF-TOKEN': token,
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                    }
                }).then(response => {
                    if (response.status === 401) {
                        window.location.href = '/logout';
                        return null;
                    }
                    if (response.status === 404 || response.status === 403) {
                        window.location.href = '/';
                        return null;
                    }
                    return response.json();
                }).then(data => {
                    // console.log('authstatusdata', data);
                    if (data.status === 'error') {
                        ResetUserState();
                        window.location.href = '/logout';
                        return;
                    }
                    setStatus(data);
                }).catch(error => {
                    console.error('Error fetching data');
                    ResetUserState();
                    window.location.href = '/logout';
                    setError(error);
                    return;
                });

            } catch (error) {
                console.error('Error fetching user:', error);
                setError(error);
                localStorage.removeItem('token'); // Si el token es inválido, elimínalo
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
    }, [dispatch]);

    return {
        status,
        loading,
        error
    };

};

export default useAuthStatus;